<template>
	<div class="goods">
		<v-head :title="title"></v-head>
		<div class="content">
		
		<div class="contBox">
			<div class="fontBocs">
				<van-icon name="balance-pay" />
                <h4>等待支付费用</h4>
			</div>
			
			<div>订单号：{{this.state}}</div>
			<div>订单金额：{{this.order.amount}}</div>
		</div>
	</div>
	<div class="embut">
      <el-button type="primary" @click="submit" class="buttonBox">立即支付</el-button>
    </div>
</div>
</template>

<script type="text/javascript">
import vHead from "../../components/Subhead.vue";

import { mapState } from "vuex";
import { Uploader,Toast,Icon} from "vant";
import {
	underLineSubmit,
	getOpenid,
	getWXCode,
	getOrderDetails
} from "@/api/dictionary";
export default {
  data() {
    return {
      fileList: [],
	  commentImg:[],
	  title:"线上支付",
	  code:null,
	  state:null,
	  WxUser:{
		  openid:null
	  },
	  order:{
		  amount:null
	  },
	//   res:null,
	//   ok:null,
	//   cancel:null,
	//   other:null,
	//   in:null,
	//   msg:null,
	//   a:null,
	//   b:null,
	//   c:null,
	//   d:null,
	//   e:null,
	//   f:null,
	//   g:null,
	//   h:null
    }
  },
    components: {
    vHead,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Icon.name]: Icon,

  },
  computed:{
  	orderId(){
  		return this.$route.query&&this.$route.query.orderId;
	},
	...mapState(["userInfo"])
},
	methods: {
		afterRead(item){

			let params = new FormData();
			params.append("file", item.file);
			params.append("memberId",this.userInfo.id);
			params.append("orderId",this.orderId);
			params.append("memberCategory",this.userInfo.memberCategory);
			underLineSubmit(params).then(res => {
				if (res.success) {
					this.titleFileId = res.result.id;
					Toast("上传成功");
						this.$router.push({ name: 'PaymentList'});
				} else {
					Toast("上传失败");
				}
			});
		},
		obj() {
			var obj = {
				orderId: this.$route.params.id
			};

			if (this.userInfo && this.from == "member") {
				obj.memberId = this.userInfo.id;
				obj.memberCategory = this.userInfo.memberCategory;
			}

			return obj;
		},
		getQueryString(name) {
			var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
			var r = window.location.search.substr(1).match(reg);
			if (r!=null) return r[2]; return '';

			},
		getO(code){
			getOpenid({code:code})
			.then(res=>{
				if(res.success){
					this.WxUser = res.result;
				}
			})
		getOrderDetails({orderNo:this.state})
			.then(res=>{
				this.order = res.result;
			})
		},
 getWxBridge(res){
	 this.res = res;
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
          }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
              document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
          }
        }else{
			//onBridgeReady(res);
		}
	},
    onBridgeReady(data){
		var that = this
      WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            "appId":data.appid,
            "timeStamp":data.timeStamp,
            "nonceStr":data.nonceStr,
            "package":"prepay_id=" + data.prepayId,
            "signType":"MD5",
            "paySign":data.sign
          },
          function(res){
			  //that.f=  JSON.stringify(res);
          if(res.err_msg == "get_brand_wcpay_request:ok"){
              // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。

				//that.ok = JSON.stringify(res);
				that.$router.push({ name: 'PaymentList'});
          }else if(res.err_msg == "get_brand_wcpay_request:cancel"){
			 // that.cancel = JSON.stringify(res);

          }else{
			  //that.other= JSON.stringify(res);
          }
      });
	},
	orderDetails(){
		let params = {
        orderNo: this.order.orderNo,
		totalFee: this.order.amount,
		openid:this.WxUser.openid,
		tradeType:"JSAPI"
      };

      getWXCode(params)
        .then(res => {
          this.getWxBridge(res);
          this.onBridgeReady(res);

        })
	},
	submit(){
	  if(!this.WxUser.openid){
		  this.$tips.error("付款失败");
		  return;
	  }
	  this.orderDetails();

	},

 },
mounted(){
	 this.code = this.getQueryString("code");
	 this.state = this.getQueryString("state");
	 this.getO(this.code);
	 this.getWxBridge();

}
};
</script>

<style type="text/css" lang="less" scoped>
.content{background: #378be1; position:relative; height: 3rem; }
.goods{ position: fixed; height: 100%; width: 100%; background: #efefef; }

/deep/.van-nav-bar .van-icon{
  color: #fff;
}
.contBox div{font-size: 16px; color: #333; margin-top: 20px;    font-family: Arial,Helvetica,sans-serif;}
.contBox{background: #fff; padding:5% 20px 10% 20px; width: 81%; position: absolute; left:4%; border-radius: 8px;
	top: 30%;
 h4{ color: #378be1; font-size: 16px; font-weight: bold; margin-bottom: 20px; }
}
.embut{ display: inline-block; width: 100%; text-align: center; margin-top: 40%; }
.buttonBox{ background: #fda005;   border-radius: 5px; width:90%; color: #fff; 
	margin:0 18px; text-align: center; font-size:16px; height: 46px; line-height: 46px; display: inline-block;
margin-top: 50px;}
.fontBocs{ color: #378be1 !important; text-align:center; margin-bottom: 40px; }
.fontBocs i{ font-size:40px !important; margin-bottom: 20px;}
</style>